<template>
    <div class="entire_client_app__sidebar">
       
        <div class="user_account_container">
            <div class="user_avatar">
                <div class="image">
                    <img v-if="$store.state.UserDetails.user.photo ==''" src="../assets/default.png" alt="avatar">
                    <img v-else :src="$store.state.UserDetails.user.photo" alt="avatar">
                </div>
            </div>

            <div class="user_details">
                <h2>{{ $store.state.UserDetails.user.firstname }} {{ $store.state.UserDetails.user.lastname}}</h2>
                <div class="promo_level_container">
                    <p>{{ levelOfPromotion }}</p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 5 5">
                        <g id="level_separator" data-name="level separator" fill="#1d2329" stroke="#1d2329" stroke-width="1">
                            <circle cx="2.5" cy="2.5" r="2.5" stroke="none"/>
                            <circle cx="2.5" cy="2.5" r="2" fill="none"/>
                        </g>
                    </svg>
                    <p class="level_grades">{{ levelsOfProGrade }}</p>
                </div>
            </div>

        </div>
        <div class="navigation_container">
            <div class="navigation_links">

                <router-link to="/dashboard" @click="$store.commit('Customizations/togglemobilesidebar')">
                    <div class="navigation_link_content">
                        <div :class="{'--sidebar_toggled_hide_link_icon_full_width': $store.state.SidebarToggle.sidebar_toggled}" class="link_icon">
                            <svg id="dashboard-line" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                                <path id="Path_13" data-name="Path 13" d="M0,0H28V28H0Z" fill="none"/>
                                <path class="active_icon" id="Path_14" data-name="Path 14" d="M15.222,25V12.778H25V25ZM3,15.222V3h9.778V15.222Zm7.333-2.444V5.444H5.444v7.333ZM3,25V17.667h9.778V25Zm2.444-2.444h4.889V20.111H5.444Zm12.222,0h4.889V15.222H17.667ZM15.222,3H25v7.333H15.222Zm2.444,2.444V7.889h4.889V5.444Z" transform="translate(0 0)" fill="#1D2329"/>
                            </svg>
                        </div>
                        <div :class="{'--sidebar_toggled_hide_link_name': $store.state.SidebarToggle.sidebar_toggled}" class="link_name">Dashboard</div>
                    </div>
                </router-link>
                
                <router-link to="/myTickets/bus" @click="$store.commit('Customizations/togglemobilesidebar')">
                    <div class="navigation_link_content">
                        <div :class="{'--sidebar_toggled_hide_link_icon_full_width': $store.state.SidebarToggle.sidebar_toggled}" class="link_icon">
                            <svg id="card" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                                <path id="Path_15" data-name="Path 15" d="M0,0H28V28H0Z" fill="none"/>
                                <path class="active_icon" id="Path_16" data-name="Path 16" d="M3.2,3H24.8A1.211,1.211,0,0,1,26,4.222V23.778A1.211,1.211,0,0,1,24.8,25H3.2A1.211,1.211,0,0,1,2,23.778V4.222A1.211,1.211,0,0,1,3.2,3Zm20.4,9.778H4.4v9.778H23.6Zm0-2.444V5.444H4.4v4.889Zm-7.2,7.333h4.8v2.444H16.4Z" transform="translate(0 0)" fill="#1d2329"/>
                            </svg>
                        </div>
                        <div :class="{'--sidebar_toggled_hide_link_name': $store.state.SidebarToggle.sidebar_toggled}" class="link_name">My tickets</div>
                    </div>
                </router-link>

                <router-link to="/routes" @click="$store.commit('Customizations/togglemobilesidebar')">
                    <div class="navigation_link_content">
                        <div :class="{'--sidebar_toggled_hide_link_icon_full_width': $store.state.SidebarToggle.sidebar_toggled}" class="link_icon">
                            <svg id="route-line" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                                <path id="Path_17" data-name="Path 17" d="M0,0H28V28H0Z" fill="none"/>
                                <path class="active_icon" id="Path_18" data-name="Path 18" d="M4.571,15V8.5c0-2.485,2.4-4.5,5.357-4.5s5.357,2.015,5.357,4.5v7A2.769,2.769,0,0,0,18.262,18a2.769,2.769,0,0,0,2.976-2.5V8.83a2.983,2.983,0,0,1-2.331-3.337A3.454,3.454,0,0,1,22.428,3,3.454,3.454,0,0,1,25.95,5.493,2.983,2.983,0,0,1,23.619,8.83V15.5c0,2.485-2.4,4.5-5.357,4.5S12.9,17.985,12.9,15.5v-7A2.769,2.769,0,0,0,9.928,6,2.769,2.769,0,0,0,6.952,8.5V15h3.571L5.762,20,1,15ZM22.428,7a1.108,1.108,0,0,0,1.19-1,1.209,1.209,0,0,0-2.381,0A1.108,1.108,0,0,0,22.428,7Z" transform="translate(0)" fill="#1d2329"/>
                            </svg>
                        </div>
                        <div :class="{'--sidebar_toggled_hide_link_name': $store.state.SidebarToggle.sidebar_toggled}" class="link_name">Available routes</div>
                    </div>
                </router-link>
 
                <!-- <router-link to="/geoMap">
                    <div class="navigation_link_content">
                        <div :class="{'--sidebar_toggled_hide_link_icon_full_width': $store.state.SidebarToggle.sidebar_toggled}" class="link_icon">
                            <svg id="road-map-line" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                                <path id="Path_19" data-name="Path 19" d="M0,0H28V28H0Z" fill="none"/>
                                <path class="active_icon" id="Path_20" data-name="Path 20" d="M4.4,7.123V22.389l6.078-2.583,7.2,3.571,5.922-2.52V5.592l1.564-.664a.6.6,0,0,1,.567.05.594.594,0,0,1,.27.5V22.429L17.6,26l-7.2-3.571L2.836,25.644a.6.6,0,0,1-.567-.05A.594.594,0,0,1,2,25.1V8.143Zm14.692,6.071L14,18.244l-5.092-5.05a7.1,7.1,0,0,1,0-10.1,7.241,7.241,0,0,1,10.182,0,7.1,7.1,0,0,1,0,10.1ZM14,14.877l3.394-3.368a4.735,4.735,0,0,0,0-6.735,4.827,4.827,0,0,0-6.789,0,4.735,4.735,0,0,0,0,6.735Z" fill="#1d2329"/>
                            </svg>
                        </div>
                        <div :class="{'--sidebar_toggled_hide_link_name': $store.state.SidebarToggle.sidebar_toggled}" class="link_name">Geo map</div>
                    </div>
                </router-link> -->

                <router-link to="/contactUs" @click="$store.commit('Customizations/togglemobilesidebar')">
                    <div class="navigation_link_content">
                        <div :class="{'--sidebar_toggled_hide_link_icon_full_width': $store.state.SidebarToggle.sidebar_toggled}" class="link_icon">
                            <svg id="customer-service-2-line" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                                <path id="Path_23" data-name="Path 23" d="M0,0H28V28H0Z" fill="none"/>
                                <path class="active_icon" id="Path_24" data-name="Path 24" d="M23.381,9.273h1.255A2.364,2.364,0,0,1,27,11.636v4.727a2.364,2.364,0,0,1-2.364,2.364H23.381A9.456,9.456,0,0,1,14,27V24.636a7.091,7.091,0,0,0,7.091-7.091V10.454a7.091,7.091,0,1,0-14.182,0v8.273H3.364A2.364,2.364,0,0,1,1,16.364V11.636A2.364,2.364,0,0,1,3.364,9.273H4.619a9.456,9.456,0,0,1,18.763,0ZM3.364,11.636v4.727H4.545V11.636Zm20.091,0v4.727h1.182V11.636ZM8.989,18.473l1.253-2a7.1,7.1,0,0,0,7.516,0l1.253,2a9.461,9.461,0,0,1-10.022,0Z" transform="translate(0)" fill="#1d2329"/>
                            </svg>
                        </div>
                        <div :class="{'--sidebar_toggled_hide_link_name': $store.state.SidebarToggle.sidebar_toggled}" class="link_name">Contact Us</div>
                    </div>
                </router-link>

                <router-link to="/notifications" @click="$store.commit('Customizations/togglemobilesidebar')">
                    <div class="navigation_link_content">
                        <div :class="{'--sidebar_toggled_hide_link_icon_full_width': $store.state.SidebarToggle.sidebar_toggled}" class="link_icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28">
                                <path fill="none" d="M0 0h24v24H0z"/>
                                <path class="active_icon" d="M22 20H2v-2h1v-6.969C3 6.043 7.03 2 12 2s9 4.043 9 9.031V18h1v2zM5 18h14v-6.969C19 7.148 15.866 4 12 4s-7 3.148-7 7.031V18zm4.5 3h5a2.5 2.5 0 1 1-5 0z" fill="#1d2329"/>
                            </svg>
                        </div>
                        <div :class="{'--sidebar_toggled_hide_link_name': $store.state.SidebarToggle.sidebar_toggled}" class="link_name">Notifications</div>
                    </div>
                </router-link>

                 <router-link to="/provider" v-if="$store.state.UserDetails.user.role == 'provider'">
                    <div class="navigation_link_content">
                        <div :class="{'--sidebar_toggled_hide_link_icon_full_width': $store.state.SidebarToggle.sidebar_toggled}" class="link_icon">
                            <svg id="customer-service-2-line" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32">
                                <path id="Path_23" data-name="Path 23"  fill="none" d="M0 0h24v24H0z"/>
                                <path class="active_icon" d="M15 3h6v5h-2V5h-4V3zM9 3v2H5v3H3V3h6zm6 18v-2h4v-3h2v5h-6zm-6 0H3v-5h2v3h4v2zM3 11h18v2H3v-2z" transform="translate(0)" fill="#1d2329"/>
                            </svg>
                        </div>
                        <div :class="{'--sidebar_toggled_hide_link_name': $store.state.SidebarToggle.sidebar_toggled}" class="link_name">Provider panel</div>
                    </div>
                </router-link>

                <router-link to="/shaloi" v-if="$store.state.UserDetails.user.role == 'shaloi'">
                    <div class="navigation_link_content">
                        <div :class="{'--sidebar_toggled_hide_link_icon_full_width': $store.state.SidebarToggle.sidebar_toggled}" class="link_icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32">
                                <path fill="none" d="M0 0h24v24H0z"/>
                                <path class="active_icon" d="M8.586 17H3v-2h18v2h-5.586l3.243 3.243-1.414 1.414L13 17.414V20h-2v-2.586l-4.243 4.243-1.414-1.414L8.586 17zM5 3h14a1 1 0 0 1 1 1v10H4V4a1 1 0 0 1 1-1zm1 2v7h12V5H6z" fill="#1d2329"/>
                            </svg>
                        </div>
                        <div :class="{'--sidebar_toggled_hide_link_name': $store.state.SidebarToggle.sidebar_toggled}" class="link_name">Shaloi panel</div>
                    </div>
                </router-link>

                <router-link to="/admin" v-if="$store.state.UserDetails.user.role == 'admin'">
                    <div class="navigation_link_content">
                        <div :class="{'--sidebar_toggled_hide_link_icon_full_width': $store.state.SidebarToggle.sidebar_toggled}" class="link_icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32">
                                <path fill="none" d="M0 0h24v24H0z"/>
                                <path class="active_icon" d="M8.586 17H3v-2h18v2h-5.586l3.243 3.243-1.414 1.414L13 17.414V20h-2v-2.586l-4.243 4.243-1.414-1.414L8.586 17zM5 3h14a1 1 0 0 1 1 1v10H4V4a1 1 0 0 1 1-1zm1 2v7h12V5H6z" fill="#1d2329"/>
                            </svg>
                        </div>
                        <div :class="{'--sidebar_toggled_hide_link_name': $store.state.SidebarToggle.sidebar_toggled}" class="link_name">Admin panel</div>
                    </div>
                </router-link>

            </div>
            <button @click="logout">Logout now</button>
        </div>
        
        <div class="logout_btn">
            <p>Powered by Zexos Group</p>
        </div>     
    </div>
</template>

<script>
    import router from '../router/index'
    // import { mapState } from 'vuex'

    export default {
        name: "Sidebar",

        data() {
            return { 
                currentuser: new String(),
                levelOfPromotion: "Intermediate",
                levelsOfProGrade: "2 levels",
                companies: [
                    "Volcano Ltd",
                    "Matunda Express",
                    "Stella Yigitarama"
                ]
            }
        },
        
        methods: {
            logout() {
                localStorage.removeItem("jwt");
                router.push("/")
            }
        },

        // created() {
        //     var userDataToDisplay = this.$store.state.UserDetails.user.data
        //     Object.assign(this.user, userDataToDisplay)       
        // },

        computed: {
            user() {
                
                var userDataToDisplay = this.$store.state.UserDetails.user;
                return Object.assign(this.currentuser, userDataToDisplay);  
                
            },                

        },

        mounted() {
            // this.$store.dispatch.userData("getUser")
            this.$store.dispatch('UserDetails/getUser')
        }
   }
</script>

<style lang="scss" scoped>

    .entire_client_app__sidebar {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-around;
        flex-direction: column;

        & .user_account_container {
            height: 17%;
            width: 100%;
            margin-top: 8%;

            .user_avatar {
                height: 50%;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;                
                position: relative;

                & .image {
                    width: 5em;
                    height: 5em;
                    overflow: hidden;
                    border-radius: 50%;
                    // display: flex;
                    // align-items: center;
                    // justify-content: center;
                    background: $routeShadows;

                    img {
                        width: 100%;
                        height: auto;
                    }  
                } 
            }

            .user_details {
                height: 50%;
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-top: 1.2em;

                h2 {
                    color: $mainDark;
                    font-family:satoshi, $poppins;
                    font-size: 1.1em;
                }

                .promo_level_container {
                    width: 100%;
                    height: auto;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    p {
                        font-family:satoshi, $poppins;
                        font-size: 0.72em;
                        font-weight: 500;
                        color: $dimerDark;
                    }

                    svg {
                        margin: 0 0.5em;
                    }

                    .level_grades {
                        color: $mainRed !important;
                    }

                }
            }
        }

        & .navigation_container {
            height: 60%;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: $mainBlueLight;
            margin-top: 1em;

            button {
                width: 95%;
                height: 16%;
                margin-top: 2em;
                border: none;
                background: $mainBlue;
                color: $pureWhite;
                font-family:satoshi, $poppins;
                font-size: 0.86em;
                border-radius: 0.25em;
            }

            .navigation_links {
                width: 95%;
                height: 100%;
                border-radius: 0.25em;

                .navigation_link_content {
                    width: 100%;
                    height: 15%;
                    border-radius: 0.22em;
                    display: flex;
                    align-items: center;
                    margin-top: 0.5em;

                    .link_icon {
                        width: 20%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        svg {
                            width: 33%;
                        }
                    }

                    .link_name {
                        width: 80%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        font-family:satoshi, $poppins;
                        font-size: 0.88em;
                        font-weight: 580;
                    }
                }
            }
        }

        & .logout_btn {
            width: 100%;
            height: 5%;
            display: flex;
            justify-content: center;
            align-items: center;

            p {
                font-family:satoshi, $poppins;
                font-size: 0.8em;
                opacity: 0.7;
            }
        }

    }
</style>